import { ModuleType } from "i18next";
import { Language } from "@types";

const LOCALES_WITH_SPECIAL_NUMERALS = [Language.BN];

const getNumericValue = (val: any): number | undefined => {
  if (typeof val === "string") {
    const trimmed = val.trim();
    val = trimmed === "" ? NaN : Number(trimmed);
  }
  return isFinite(val) ? val : undefined;
};

const FormatNumber = {
  type: "formatter" as ModuleType,
  init() {},
  format(value: any, format: string, lng: Language) {
    // NOTE: This is currently safe to use in this context because we don't use any other formats,
    // and all numeric string variables should be translated.
    // However, if things change in the future, we may need to revisit this and add extra conditions.
    const numericValue = getNumericValue(value);
    if (!format && numericValue !== undefined && lng && LOCALES_WITH_SPECIAL_NUMERALS.includes(lng)) {
      try {
        return new Intl.NumberFormat(lng).format(numericValue);
      } catch (e) {
        return String(numericValue); // Fallback
      }
    }

    return String(value);
  },
};

export default FormatNumber;
